import differenceInMinutes from 'date-fns/differenceInMinutes';

export default function getTextForDcardDelivery(localStorageData) {
    const { date: cardOrderDate, orderType, deliveryDate, endTime } = localStorageData;
    const minutesFromOrderDate = differenceInMinutes(new Date(), new Date(cardOrderDate));

    const twoWeeksInMinutes = 20160;
    if (minutesFromOrderDate >= twoWeeksInMinutes && orderType === 'office') {
        return 'moreTwoWeeks';
    }
    if (minutesFromOrderDate <= twoWeeksInMinutes && orderType === 'office') {
        return 'orderOffice';
    }

    const endTimeDeliveryDate = new Date(`${deliveryDate}T${endTime}`);
    const minutesToDeliveryDate = deliveryDate && differenceInMinutes(new Date(), endTimeDeliveryDate);

    if (!Number.isNaN(minutesToDeliveryDate) && orderType === 'courier') {
        if (minutesToDeliveryDate <= 0) {
            return 'beforeDelivery';
        }
        if (minutesToDeliveryDate <= twoWeeksInMinutes) {
            return 'afterDelivery';
        }
        if (minutesToDeliveryDate >= twoWeeksInMinutes) {
            return 'moreTwoWeeks';
        }
    }
    return '';
}
